import type { NFStatus } from '../../shared/types';

/** Rótulo, cor do badge e cor do marcador de cada status da NF. */
export const NF_STATUS_META: Record<NFStatus, { label: string; badge: string; dot: string }> = {
  liberada: { label: 'Liberada', badge: 'bg-sky-100 text-sky-800', dot: 'bg-sky-500' },
  em_analise: { label: 'Em análise', badge: 'bg-amber-100 text-amber-800', dot: 'bg-amber-500' },
  aprovada: { label: 'Aprovada', badge: 'bg-emerald-100 text-emerald-800', dot: 'bg-emerald-500' },
  rejeitada: { label: 'Rejeitada', badge: 'bg-red-100 text-red-800', dot: 'bg-red-500' },
  faturada: { label: 'Faturada', badge: 'bg-violet-100 text-violet-800', dot: 'bg-violet-500' },
};

export const NF_STATUS_ORDER: NFStatus[] = ['liberada', 'em_analise', 'aprovada', 'rejeitada', 'faturada'];

export const formatCurrency = (value: number | null | undefined) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value ?? 0);

/** `2026-09` → `09/2026`. */
export const formatCompetencia = (month: string) => {
  const [year, m] = month.split('-');
  return m && year ? `${m}/${year}` : month;
};

export const formatDate = (value?: string | null) =>
  value ? new Intl.DateTimeFormat('pt-BR').format(new Date(value)) : '—';

/** Data da última mudança de status, para a coluna da tabela. */
export const lastChange = (nota: {
  invoicedAt?: string | null;
  reviewedAt?: string | null;
  submittedAt?: string | null;
  releasedAt?: string | null;
  updatedAt: string;
}) => nota.invoicedAt ?? nota.reviewedAt ?? nota.submittedAt ?? nota.releasedAt ?? nota.updatedAt;

/** Mensagem do backend (string ou lista do class-validator) ou um padrão. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const message = (err as { response?: { data?: { message?: string | string[] } } }).response?.data?.message;
  if (Array.isArray(message)) return message.join(', ');
  return message ?? fallback;
}
